import { useState } from "react";

// Shopify görseli yüklenemezse (ör. mağaza geçici kapalıyken) markalı kart gösterir.
// Mağaza açıldığında gerçek fotoğraflar otomatik geri gelir.
export const ProductImage = ({ src, alt, className = "", testId }) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div
        className={`${className} flex flex-col items-center justify-center bg-sand`}
        data-testid={testId}
        role="img"
        aria-label={alt}
      >
        <span className="font-serif text-3xl font-semibold text-emerald/20">
          A<span className="italic">S</span>
        </span>
        <span className="mt-2 px-3 text-center font-mono text-[9px] uppercase tracking-[0.2em] text-sage/70 line-clamp-2">
          {alt}
        </span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={className}
      data-testid={testId}
    />
  );
};
